import type {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';
import {isPublicMode} from 'common/report/util';
import {useCurrentProject} from 'common/contexts/react/current-project-context';

export function isGlobalSidenavEnabled(currentProject?: CurrentProject | ProjectDetails): boolean {
  if (!currentProject) {
    return false;
  }

  return Boolean(currentProject.hasFeatureFlag(ProjectFeatureFlag.GlobalSidenav));
}

export function useIsGlobalSidenavEnabled() {
  const currentProject = isPublicMode() ? undefined : useCurrentProject().get().value;
  return isGlobalSidenavEnabled(currentProject);
}
